import { useMemo, useState } from 'react';
import { LoadingOverlay } from '@airtm/airtm-ui';
import PublicHeader from 'routes/PublicHeader';
import useMe from 'utils/hooks/useMe/useMe';
import JwtManager from 'lib/JwtManager';
import ProviderConnection from 'screens/SignUp/ProviderConnection/ProviderConnection';
import { LOCAL_STORAGE } from '@constants';

export default function withInvalidProvider(Component) {
  const WithInvalidProviderWrapper = function (props) {
    const { loading, custodialProvider } = useMe({
      include: { enterprise: true },
      fetchPolicy: 'cache-and-network',
      skip: !JwtManager.jwt,
    });

    const [isDismissed, setIsDismissed] = useState(false);
    const skipSelectProvider = localStorage.getItem(LOCAL_STORAGE.SKIP_SELECT_PROVIDER);

    const showSelectProvider = useMemo(() => {
      if (loading || isDismissed) {
        return false;
      }
      return custodialProvider === null && !skipSelectProvider;
    }, [loading, custodialProvider, skipSelectProvider, isDismissed]);

    const skip = ({ showEnable2FAScreen = true }) => {
      if (showEnable2FAScreen) {
        localStorage.setItem(LOCAL_STORAGE.SHOW_ENABLE_2FA_SCREEN, 'true');
      }
      localStorage.setItem(LOCAL_STORAGE.SKIP_SELECT_PROVIDER, 'true');
      setIsDismissed(true);
    };

    if (loading) return <LoadingOverlay />;

    if (showSelectProvider) {
      return (
        <>
          <PublicHeader />
          <ProviderConnection skip={skip} />
        </>
      );
    }

    return <Component {...props} />;
  };

  return WithInvalidProviderWrapper;
}
